export default "__VITE_ASSET__Bjq3z9e2__"